import React from 'react';
import Table from '../Table/Table';

const SubcategoriesTable = ({
  title,
  data = [],
  columns = [],
  currentPage = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  tableHeight
}) => {

  return (
    <div className="subcategories-table-container">
      <h2 style={{ textAlign: 'center' }}>{title}</h2>
      <Table 
        columns={columns}
        data={data}
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
        headerBackground="var(--color-primary)"
        headerTextColor="var(--color-white)"
        tableHeight={tableHeight}
      />
    </div>
  );
};

export default SubcategoriesTable;
